// extracted by mini-css-extract-plugin
export default {"container":"e2-PEy1ba4zrKa9irumsA","text":"XZqGe4TCRw28_H0LEhvLy c-silver"};